import React, { useEffect, useState, useRef } from 'react';
import ReactDOM from 'react-dom';

const PortalTooltip = ({ active, payload, label, coordinate, children }) => {
  const anchorRef = useRef(null);
  const contentRef = useRef(null);
  const [pos, setPos] = useState({ top: -9999, left: -9999, opacity: 0 });

  useEffect(() => {
    if (active && coordinate && anchorRef.current) {
      // Use requestAnimationFrame to let the portal content render first so we can measure it
      requestAnimationFrame(() => {
        if (!anchorRef.current || !contentRef.current) return;
        
        const wrapper = anchorRef.current.closest('.recharts-wrapper');
        if (wrapper) {
          const rect = wrapper.getBoundingClientRect();
          const tooltipRect = contentRef.current.getBoundingClientRect();
          
          let left = rect.left + coordinate.x + 15;
          let top = rect.top + coordinate.y + 15;

          // Smart flip Left/Right relative to viewport
          if (left + tooltipRect.width > window.innerWidth - 15) {
            left = rect.left + coordinate.x - tooltipRect.width - 15;
          }

          // Smart flip Top/Bottom relative to viewport
          if (top + tooltipRect.height > window.innerHeight - 15) {
            top = rect.top + coordinate.y - tooltipRect.height - 15;
          }
          
          setPos({ top, left, opacity: 1 });
        }
      });
    } else {
      setPos(p => ({ ...p, opacity: 0 }));
    }
  }, [active, coordinate, payload]);

  if (!active || !payload || !payload.length) return null;

  return (
    <div ref={anchorRef} style={{ display: 'none' }}>
      {ReactDOM.createPortal(
        <div 
          ref={contentRef}
          className="bg-white/95 backdrop-blur-md border border-slate-200 p-3 rounded-lg shadow-xl text-xs pointer-events-none fixed z-[99999]"
          style={{ 
            top: pos.top, 
            left: pos.left, 
            opacity: pos.opacity,
          }}
        >
          {children}
        </div>,
        document.body
      )}
    </div>
  );
};

export default PortalTooltip;
